export default __webpack_public_path__ + "static/media/YT.84707b1e.svg";